<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>礼物互赠</span>
      </div>

      <el-form>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>互赠时间</span>
              </div>
              <el-form :inline="true">
                <el-form-item label="时间范围">
                  <el-time-select
                    v-model="basic.start"
                    :picker-options="{
                      start: '00:00',
                      step: '00:15',
                      end: '23:45'
                    }"
                    placeholder="选择时间"
                  />
                </el-form-item>
                <el-form-item label="-">
                  <el-time-select
                    v-model="basic.end"
                    :picker-options="{
                      start: '00:00',
                      step: '00:15',
                      end: '23:45'
                    }"
                    placeholder="选择时间"
                  />
                </el-form-item>
              </el-form>
            </el-card>

          </el-col>
        </el-row>
        <el-button class="mtop" type="primary" @click="onSubmit()">保存</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'

export default {
  name: 'RobotAdd',
  data() {
    return {
      key: 'ROBOT_FRIEND_CONFIG:GIFT',
      basic: {
        start: '',
        end: ''
      }
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    getTables() {
      getCommonCfg({ name: this.key }).then(res => {
        this.basic = res.data
      })
    },
    onSubmit() {
      const data = JSON.stringify(this.basic)
      updateCommonCfg({ data: data, name: this.key }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
.mtop{
  margin-top: 20px;
}
</style>
